import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'task',
    serviceName: 'auth',
    query: gql`
      query task($ids: [String]) {
        task(ids: $ids) {
          data {
            status
            coupon {
              id
              title
              amount
              end_date
              start_date
              shop {
                title
              }
              products_shop {
                id
                product_info {
                  title
                  brand {
                    title
                  }
                  media {
                    full_url
                  }
                }
              }
              product_categories {
                id
                title
                media {
                  full_url
                }
              }
              users {
                id
                lastname
                firstname
                cellphone
                media {
                  full_url
                }
              }
            }
          }
        }
      }
    `,
  },
  done: {
    name: 'doneRequest',
    serviceName: 'auth',
    query: gql`
      mutation doneRequest($id: String!) {
        doneRequest(id: $id) {
          messages
        }
      }
    `,
  },
};

export default schema;
